import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {
    messages: string[] = [];

    add(message: string) {
        this.messages.push(message);
    }

    clear() {
        this.messages = [];
    }
}

export interface IframeMsg {
    type: TypeIframeMsg;
    msg?: any;
}

export interface DatePickerMsg {
    formHalachaDateValueToSet: string;
    formHdToSet: string;
    formJdToSet: number;
    formLdToSet: string;
    hdateHtmlToSet: string;
}

export enum TypeIframeMsg {
    Close,
    Load,
    Prelaod,
    Msg,
}
